export default {
  player: (context, player) => {
    context.commit('SET_PLAYER', player);
  },
  play: (context) => {
    context.commit('PLAY');
  },
  pause: (context) => {
    context.commit('PAUSE');
  },
  setPlayerCurrentTime: (context, time) => {
    context.commit('SET_PLAYER_CURRENT_TIME', time);
  },
  setPlayerDuration: (context, time) => {
    context.commit('SET_PLAYER_DURATION', time);
  },
  setPlayerTracks: (context, tracks) => {
    context.commit('SET_PLAYER_TRACKS', tracks);
  },
  setShuffleTracks: (context, shuffleTracks) => {
    context.commit('SET_SHUFFLE_TRACKS', shuffleTracks);
  },
  setOriginalTracks: (context) => {
    context.commit('SET_ORIGINAL_TRACKS');
  },
  setPlayerCurrentTrack: (context, track) => {
    axios.post(`/api/mmn/song-play/${track.id}`);
    context.commit('SET_PLAYER_CURRENT_TRACK', track);
  },
  setPlayerSeeking: (context, track) => {
    context.commit('SET_PLAYER_SEEKING', track);
  },
};
